import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import promoVideo from "../../Assets/vidio/promo.MP4"; // ✅ Adjust path if needed

export default function Hero() {
  return (
    <section
      className="pt-44 pb-36 relative overflow-hidden
      bg-[#F5F7FB] dark:bg-[#050816] transition-colors"
    >
      {/* Background glow */}
      <div className="absolute inset-0 -z-10">
        <div
          className="absolute top-[-120px] left-[-120px]
          w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-[120px]"
        />
        <div
          className="absolute bottom-[-120px] right-[-120px]
          w-[500px] h-[500px] bg-indigo-500/20 rounded-full blur-[120px]"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        {/* LEFT CONTENT */}
        <div>
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-block mb-6 px-4 py-1.5 rounded-full
            bg-blue-600/10 text-blue-600 dark:text-blue-400 text-sm font-medium"
          >
            Digital Growth · Full-Cycle Support
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl font-extrabold leading-tight
            text-[#0A0F1C] dark:text-white"
          >
            We Build Digital
            <br />
            Solutions That{" "}
            <span
              className="bg-gradient-to-r from-blue-600 via-cyan-500 to-indigo-600
              bg-clip-text text-transparent"
            >
              Drive Growth
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-8 text-lg text-slate-600 dark:text-slate-400 max-w-xl"
          >
            360Support helps businesses design, develop, and scale reliable
            digital products with performance and clarity at the core.
          </motion.p>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="mt-12 flex flex-wrap gap-4"
          >
            <Link
              to="/contact"
              className="px-8 py-4 rounded-xl font-medium text-white
              bg-blue-600 hover:bg-blue-700
              shadow-lg shadow-blue-600/30
              hover:-translate-y-1 transition"
            >
              Contact Us
            </Link>

            <Link
              to="/about"
              className="px-8 py-4 rounded-xl font-medium
              border border-slate-300 dark:border-slate-700
              hover:bg-slate-100 dark:hover:bg-slate-800 transition"
            >
              Learn More
            </Link>
          </motion.div>

          {/* Metrics */}
          <div className="mt-16 grid grid-cols-3 gap-8 max-w-lg">
            {[
              { value: "50+", label: "Projects" },
              { value: "98%", label: "Satisfaction" },
              { value: "24/7", label: "Support" },
            ].map((m) => (
              <div key={m.label}>
                <p className="text-3xl font-bold text-[#0A0F1C] dark:text-white">
                  {m.value}
                </p>
                <p className="text-sm text-slate-600 dark:text-slate-400">
                  {m.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT VIDEO SECTION */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 }}
          className="relative hidden lg:block"
        >
          <div
            className="rounded-3xl overflow-hidden
            shadow-2xl border border-black/5 dark:border-white/10"
          >
            <video
              className="w-full h-full object-cover"
              src={promoVideo}
              autoPlay
              loop
              controls
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}